import { memo, ReactElement, useCallback } from 'react';
import { Button, Form, Input } from 'antd';
import { useCallRequest } from '../hooks/useCallRequest';
import { StyledForm, FormItem, ButtonContainer } from './styles';

interface FormValues {
  rpmApplicantId: string;
}

const CallRequestForm = memo(function CallRequestForm(): ReactElement {
  const [form] = Form.useForm<FormValues>();
  const { submit, loading } = useCallRequest();

  const handleFinish = useCallback(
    async (values: FormValues) => {
      const result = await submit(values.rpmApplicantId);
      if (result.success) {
        form.resetFields();
      } else {
        form.setFields([
          {
            name: 'rpmApplicantId',
            errors: [result.errorMessage ?? '架電依頼に失敗しました'],
          },
        ]);
      }
    },
    [submit, form]
  );

  return (
    <StyledForm<FormValues> form={form} layout='vertical' onFinish={handleFinish} autoComplete='off'>
      <FormItem
        label='RPM応募者ID'
        name='rpmApplicantId'
        rules={[
          { required: true, message: 'RPM応募者IDを入力してください' },
          { max: 10, message: 'RPM応募者IDは10文字以内で入力してください' },
          { pattern: /^\d+$/, message: 'RPM応募者IDは数字のみで入力してください' },
        ]}
      >
        <Input placeholder='RPM応募者IDを入力' maxLength={10} />
      </FormItem>
      <FormItem>
        <ButtonContainer>
          <Button type='primary' htmlType='submit' loading={loading}>
            架電する
          </Button>
        </ButtonContainer>
      </FormItem>
    </StyledForm>
  );
});

export default CallRequestForm;
